export default __webpack_public_path__ + "static/precision-piece-3-d8cb1d4de2406e141151b75ba189c7dc.jpg";